import { defineComponent } from "vue";
import { TegevuseLiik } from '@/models/KohtumineTegevus';
import mixin from '@/core/mixins';

export default defineComponent({
  mixins: [mixin],
  methods: {
    ikoon(liik: TegevuseLiik | undefined) {
      switch (liik) {
        case TegevuseLiik.RegistreerimiskohustuseTäitmine:
          return 'mdi-human-male-male';
        case TegevuseLiik.VeebipõhineRegistreerimiskohustus:
          return 'mdi-laptop-account';
        case TegevuseLiik.TelefonipõhineRegistreerimiskohustus:
          return 'mdi-phone';
        case TegevuseLiik.ÜldkasulikTöö:
        case TegevuseLiik.ElektroonilineValve:
        case TegevuseLiik.ElektroonilineValveKinnitamata:
          return 'mdi-walk';
        case TegevuseLiik.HoiveProgramm:
          return 'mdi-account-group';
      }
    },
    ikooniVarv(liik: TegevuseLiik | undefined) {
      switch (liik) {
        case TegevuseLiik.RegistreerimiskohustuseTäitmine:
        case TegevuseLiik.VeebipõhineRegistreerimiskohustus:
        case TegevuseLiik.TelefonipõhineRegistreerimiskohustus:
          return 'var(--varv-icon-2)';
        case TegevuseLiik.ÜldkasulikTöö:
        case TegevuseLiik.ElektroonilineValve:
        case TegevuseLiik.HoiveProgramm:
          return 'var(--varv-icon-3)';
        case TegevuseLiik.ElektroonilineValveKinnitamata:
          return 'var(--varv-lisa-1)';
      }
    },
    selgitusePealkiri(liik: TegevuseLiik | undefined) {
      switch (liik) {
        case TegevuseLiik.RegistreerimiskohustuseTäitmine:
        case TegevuseLiik.VeebipõhineRegistreerimiskohustus:
        case TegevuseLiik.TelefonipõhineRegistreerimiskohustus:
          return 'Tegevus';
        case TegevuseLiik.ÜldkasulikTöö:
          return 'Tööandja kontakt';
        case TegevuseLiik.HoiveProgramm:
          return 'Tunni sisu';
      }
    },
    tegevuseAegFormateeritud(liik: TegevuseLiik | undefined, algusKp: string | undefined, loppKp: string | undefined) {
      switch (liik) {
        case TegevuseLiik.RegistreerimiskohustuseTäitmine:
        case TegevuseLiik.VeebipõhineRegistreerimiskohustus:
        case TegevuseLiik.TelefonipõhineRegistreerimiskohustus:
          return this.formateeriKuupaevaAjaga(algusKp);
        case TegevuseLiik.ÜldkasulikTöö:
        case TegevuseLiik.ElektroonilineValve:
        case TegevuseLiik.HoiveProgramm:
          return this.formateeriKuupaevaAjaga(algusKp) + ' - ' + this.formateeriAeg(loppKp);
        case TegevuseLiik.ElektroonilineValveKinnitamata:
          return this.formateeriKuupaev(algusKp) + ' - ' + this.formateeriKuupaev(loppKp);
      }
    },
    tegevuseAjaPealkiri(liik: TegevuseLiik | undefined) {
      switch (liik) {
        case TegevuseLiik.RegistreerimiskohustuseTäitmine:
        case TegevuseLiik.VeebipõhineRegistreerimiskohustus:
        case TegevuseLiik.TelefonipõhineRegistreerimiskohustus:
        case TegevuseLiik.ÜldkasulikTöö:
        case TegevuseLiik.ElektroonilineValve:
        case TegevuseLiik.HoiveProgramm:
          return 'Aeg';
        case TegevuseLiik.ElektroonilineValveKinnitamata:
          return 'Periood';
      }
    }
  }
});